<template>
	<div v-if="item?.withProgress||item?.isProcess" class="context-progress" :class="componentClass">

		<div v-if="withTitle" class="caption">{{title}}</div>
		<div
			v-if="totalItems"
			ref="track"
			class="context-progress__track"
			:class="{'--continuous': isContinuous}"
			:style="{height: height+'px'}"
			:title="title"
		>
			<span v-if="isContinuous" class="context-progress__bar" :style="{width: progressPercent}" />
			<template v-else>
				<span
					v-for="n in totalItems"
					:key="n"
					class="context-progress__step"
					:class="{'--done': n<=item.countDoneChildren}"
				/>
			</template>
			<span v-if="height>=16&&!compact" class="context-progress__label caption">{{ text }}</span>
		</div>
	</div>
</template>

<script>
import base from "@/mixins/base";
import vp from "@/mixins/vp";

export default {
	name: "context-progress",
	mixins: [base, vp],
	props: {
		item: {},
		height: {
			type: Number,
			default: 16,
		},
		compact: {
			type: Boolean,
			default: false,
		},
		withTitle: {
			type: Boolean,
			default: false,
		},
	},
	components: {},
	data: () => ({
		trackWidth: 0,
	}),
	computed: {
		text() {
			return "" + this.progressPercent;
		},
		totalItems() {
			return this.item.countAssignableChildren + this.item.countDoneChildren;
		},
		progress() {
			return this.item.countDoneChildren * 100 / this.totalItems;
		},
		progressPercent() {
			return this.progress.toFixed(0) + "%";
		},
		title() {
			return "Готово "+this.item.countDoneChildren + " из " + this.totalItems;
		},
		componentClass() {
			const c = [];
			if (this.compact) c.push("--compact");
			return c?.length ? c : null;
		},
		// ширина одной ячейки трека с учётом gap между ячейками
		cellWidth() {
			if (!this.totalItems || !this.trackWidth) return null;
			const gap = 2;
			return (this.trackWidth - gap * (this.totalItems - 1)) / this.totalItems;
		},
		// если ячейка становится слишком тонкой - рисуем трек одной сплошной полосой без ячеек
		isContinuous() {
			return this.cellWidth !== null && this.cellWidth < 4;
		},
	},
	methods: {
		updateTrackObserver() {
			const el = this.$refs.track;
			if (!el || this._observedEl === el) return;
			if (this._resizeObserver) this._resizeObserver.disconnect();
			if (typeof ResizeObserver !== "undefined") {
				this._resizeObserver = new ResizeObserver(entries => {
					this.trackWidth = entries[0]?.contentRect?.width ?? el.clientWidth;
				});
				this._resizeObserver.observe(el);
			}
			this._observedEl = el;
			this.trackWidth = el.clientWidth;
		},
	},
	mounted() {
		this.updateTrackObserver();
	},
	updated() {
		this.updateTrackObserver();
	},
	beforeDestroy() {
		if (this._resizeObserver) this._resizeObserver.disconnect();
	},
}
</script>

<style lang="scss">

.context-progress {
	width: 100%;

	&.--compact {
		padding: 0;

		.context-progress__track {
			gap: 2px;
		}

		.context-progress__step {
			border-radius: 2px;
		}

		.context-progress__track.--continuous,
		.context-progress__bar {
			border-radius: 2px;
		}
	}

	&__track {
		position: relative;
		width: 100%;
		height: 100%;
		display: flex;
		gap: 2px;

		// когда ячеек слишком много и они становятся тоньше 4px - трек рисуется сплошной полосой
		&.--continuous {
			background-color: color-mix(in srgb, var(--v-success-base, #4caf50) 30%, transparent);
			border-radius: 3px;
			overflow: hidden;
		}
	}

	&__step {
		flex: 1 1 0;
		min-width: 1px;
		height: 100%;
		border-radius: 3px;
		background-color: var(--v-success-base, #4caf50);
		opacity: .3;

		&.--done {
			opacity: 1;
		}
	}

	&__bar {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		border-radius: 3px;
		background-color: var(--v-success-base, #4caf50);
	}

	&__label {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		color: black;
		text-shadow: 0 0 3px white, 0 0 3px white;
		pointer-events: none;
		white-space: nowrap;
	}

	/*&__title {
		flex-shrink: 0;
		flex-grow: 0;
		white-space: nowrap;
	}*/
}

</style>
